import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import SSFRegulationsFreelancer from "../../../assets/SSFRegulationsFreelancer.pdf";
import FreelanceRequirementListBilingualFinal from "../../../assets/FreelanceRequirementListBilingualFinal.pdf";
import { ToastifyService } from "../../../services";
import { allSharedComponents } from "../../../shared";
import { BreakdownIcon } from "../../../assets/images/icon";
import {
  calculateVAT,
  getUserPayload,
  precisionCalculation,
  unloadWidget,
} from "../../../system";
import { sportNames } from "../../../modules/AdminPortal/Views/Spots/utilities";
import {
  Directions,
  subscriptionTypeConstants,
  translationConstants,
  subscriptionUserTypeEmun,
  calculationOperations,
} from "../../../constants";
import {
  instructorActions,
  paymentActions,
  SubscriptionActions,
  SpotActions,
} from "../../../redux/actions";

const { GeneralLogo, CustomModal, BaseForm, BecomeFreelanceInstructorPayment } =
  allSharedComponents;

const BecomeFreelanceInstructor = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();

  const body = {
    length: null,
  };

  const currentSAR = useRef(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userData = getUserPayload();

  const [isSailingDisabled, setSailingDisabled] = useState(true);
  const [isKitesurfingDisabled, setKitesurfingDisabled] = useState(true);
  const [isWindsurfingDisabled, setWindsurfingDisabled] = useState(true);
  const [isWingfoilingDisabled, setWingfoilingDisabled] = useState(true);
  const [isShowSmallModal, setShowSmallModal] = useState(false);
  const [selectedSpot, setSelectedSpot] = useState(false);
  const [selectedSpotId, setSelectedSpotId] = useState(false);
  const [spotId, setSpotId] = useState(null);
  const [pricing, setPricingBreakdown] = useState([]);
  const [sportIds, setSportIds] = useState([]);
  const [isMemberModal, setMemebershipModal] = useState(false);
  const [vat, setVat] = useState(0);
  const publicSpots = useSelector((state) => state.SpotsReducer?.publicSpots);

  const subscriptionPrices = useSelector(
    (state) => state.SubscriptionReducer.subscriptionPrices
  );

  const instructorSports = useSelector(
    (state) => state.InstructorReducer.instructorSports.data
  );

  const onSetShowSmallModal = () => {
    setShowSmallModal((prev) => !prev);
  };

  const membershipModalHandler = () => {
    unloadWidget();
    setMemebershipModal((prev) => !prev);
    dispatch(paymentActions.paymentCheckoutNull());
  };

  const handleSailingCheckboxChange = () => {
    setSailingDisabled(!isSailingDisabled);
    handleSAR(subscriptionTypeConstants.SAILING, isSailingDisabled);
  };

  const handleKitesurfingCheckboxChange = () => {
    setKitesurfingDisabled(!isKitesurfingDisabled);
    handleSAR(subscriptionTypeConstants.KITE_SURFING, isKitesurfingDisabled);
  };

  const handleWindsurfingCheckboxChange = () => {
    setWindsurfingDisabled(!isWindsurfingDisabled);
    handleSAR(subscriptionTypeConstants.WIND_SURFING, isWindsurfingDisabled);
  };

  const handleWingfoilingCheckboxChange = () => {
    setWingfoilingDisabled(!isWingfoilingDisabled);
    handleSAR(subscriptionTypeConstants.WING_FOILING, isWingfoilingDisabled);
  };

  useEffect(() => {
    if (publicSpots) {
      dispatch(
        SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
      );
      dispatch(SpotActions.GetAllPublicSpots(body));
      dispatch(instructorActions.getInstructorsSports(userData?.user?.id));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const data = subscriptionPrices.filter(
      (x) => x.subcriptionType === subscriptionTypeConstants.VAT
    );

    if (data[0] && data[0].price) setVat(data[0].price);
    //eslint-disable-next-line
  }, [subscriptionPrices]);

  const handleSAR = (constant, type) => {
    const data = subscriptionPrices.filter(
      (x) =>
        x.subcriptionType === constant &&
        x.userType === subscriptionUserTypeEmun.FREELANCE
    );

    if (type) {
      currentSAR.current += data[0]?.price;
      setPricingBreakdown([
        ...pricing,
        { sport: constant, price: data[0]?.price },
      ]);
      setSportIds([...sportIds, constant]);
    } else {
      currentSAR.current -= data[0]?.price;
      setPricingBreakdown(pricing.filter((x) => x.sport !== constant));
      setSportIds(sportIds.filter((x) => x !== constant));
    }
  };

  const onSubmit = (e) => {
    if (sportIds.length <= 0) {
      ToastifyService.showError(t(translationConstants.SELECT_ONE_SPORT));
    } else {
      setSpotId(e.primaryLocation);
      membershipModalHandler();
    }
  };

  useEffect(() => {
    if (selectedSpot) {
      const availableSports = selectedSpot?.sportIds?.filter((sportId) =>
        instructorSports?.includes(sportId)
      );
      availableSports?.map((sportId) => setValue(sportNames[sportId], false));
      setPricingBreakdown([]);
      setSportIds([]);
      currentSAR.current = 0;
      setSailingDisabled(true);
      setKitesurfingDisabled(true);
      setWindsurfingDisabled(true);
      setWingfoilingDisabled(true);
    }
    //eslint-disable-next-line
  }, [selectedSpot, reset]);

  const handleSpotChange = (event) => {
    const selectedSpotId = event.target.value;
    setSelectedSpotId(selectedSpotId);
    const spot = publicSpots.find((spot) => spot.id === selectedSpotId);
    setSelectedSpot(spot);
  };

  const renderCheckboxes = () => {
    if (!selectedSpot) {
      return <p>{t(translationConstants.PLEASE_SELECT_A_PRIMARY_LOCATION)}</p>;
    }

    if (!instructorSports) {
      return null;
    }

    const availableSports = selectedSpot.sportIds.filter((sportId) =>
      instructorSports.includes(sportId)
    );

    if (availableSports?.length === 0) {
      return <p>{t(translationConstants.NO_COMMON_SPORTS_FOUND)}</p>;
    }

    return availableSports?.map((sportId) => (
      <div className="col-6 my-2" key={sportId}>
        <Form.Group controlId={`formBasicCheckbox${sportId}`}>
          <Form.Check
            className="offer"
            type="checkbox"
            label={
              <p>
                {t(translationConstants[sportNames[sportId].toLowerCase()])}{" "}
              </p>
            }
            {...register(sportNames[sportId])}
            onChange={() => {
              switch (sportId) {
                case subscriptionTypeConstants.SAILING:
                  handleSailingCheckboxChange();
                  break;
                case subscriptionTypeConstants.KITE_SURFING:
                  handleKitesurfingCheckboxChange();
                  break;
                case subscriptionTypeConstants.WIND_SURFING:
                  handleWindsurfingCheckboxChange();
                  break;
                case subscriptionTypeConstants.WING_FOILING:
                  handleWingfoilingCheckboxChange();
                  break;
                default:
                  break;
              }
            }}
          />
          {errors[sportNames[sportId]] && (
            <p className="errorText">{errors[sportNames[sportId]].message}</p>
          )}
        </Form.Group>
      </div>
    ));
  };

  const getTotalPriceYearly = useMemo(() => {
    return precisionCalculation(
      calculateVAT(vat, currentSAR.current),
      currentSAR.current,
      calculationOperations.addition
    );
    //eslint-disable-next-line
  }, [vat, currentSAR.current]);

  return (
    <>
      <div>
        <CustomModal
          size="sm"
          scrollable={true}
          setShow={props.setShow}
          show={props.isShow}
          closeBtnClasses={"login-modal-close-btn"}
        >
          <BaseForm>
            <GeneralLogo />
            <section
              id="content"
              className="freelance-instructor d-flex flex-column align-content-start"
            >
              <section id="form">
                <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                  <div className="col-10">
                    <p className="heading">
                      {t(translationConstants.BECOME_FREELANCE_INSTRUCTOR)}
                    </p>
                    <Form.Group className="form-group">
                      <Form.Label className="label">
                        {t(
                          translationConstants.SELECT_PRIMARY_TEACHING_LOCATION
                        )}
                      </Form.Label>
                      <Form.Select
                        className="custom-select-icon"
                        {...register("primaryLocation", {
                          required: t(
                            translationConstants.PRIMARY_LOCATION_IS_REQUIRED
                          ),
                        })}
                        value={selectedSpotId}
                        onChange={handleSpotChange}
                      >
                        <option value="">
                          {t(translationConstants.SELECT_PRIMARY_LOCATION)}
                        </option>
                        {publicSpots?.map((spot) => (
                          <option key={spot?.id} value={spot?.id}>
                            {spot?.name}
                          </option>
                        ))}
                      </Form.Select>
                      {errors.primaryLocation && (
                        <p className="errorText">
                          {errors.primaryLocation.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>
                  <div className="align-items-center registrationCheckBoxs">
                    <p className="choose-sport">
                      {t(translationConstants.CHOOSE_SPORTS_YOU_OFFER)}:
                    </p>
                    <div className="mt-3">
                      <div className="row checkbox">
                        <div className="d-flex flex-wrap justify-content-between col-md-12 mb-3 px-0">
                          {renderCheckboxes()}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mx-0 w-100">
                    <div className="d-flex px-0 justify-content-between">
                      <p className="total-fee">
                        {t(translationConstants.TOTAL_FEE)}: (
                        {t(translationConstants.YEARLY)})
                      </p>
                      <p className="total-fee">
                        {translationConstants.SAR} {getTotalPriceYearly}
                        <img
                          alt="info-icon"
                          src={BreakdownIcon}
                          className="info-icon"
                          onClick={onSetShowSmallModal}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="row w-100">
                    <p className="sport-selected">
                      {" "}
                      {t(translationConstants.FEE_WILL_BE_CALCULATED)}
                    </p>
                  </div>
                  <div className="row w-100 mt-3">
                    <div className="d-flex flex-column col-md-12">
                      <Form.Group
                        className="d-flex align-items-center justify-content-space-between registrationCheckBoxs"
                        controlId="formBasicCheckbox6"
                      >
                        <Form.Check
                          className="required-checkbox offer m-0"
                          type="checkbox"
                          label={
                            <p className="fs-10">
                              {t(translationConstants.I_OWN_ALL_ITEMS)}
                            </p>
                          }
                          {...register("requirementList", {
                            required: t(
                              translationConstants.AGREE_TO_TERMS_REQUIRED
                            ),
                          })}
                        />
                        <span
                          onClick={() => window.open(FreelanceRequirementListBilingualFinal)}
                          className="fs-10 link-style ms-1"
                        >
                          {`${t(translationConstants.REQUIREMENT_LIST)}.`}
                        </span>{" "}
                        {errors.requirementList && (
                          <p className="errorText">
                            {errors.requirementList.message}
                          </p>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                  <div className="row w-100">
                    <div className="d-flex flex-column col-md-12 mb-3">
                      <Form.Group
                        className="d-flex align-items-center justify-content-space-between registrationCheckBoxs"
                        controlId="formBasicCheckbox7"
                      >
                        <Form.Check
                          className="required-checkbox offer m-0"
                          type="checkbox"
                          label={
                            <p className="fs-10">
                              {t(translationConstants.agreeToTerms)}
                            </p>
                          }
                          {...register("freelanceRegulation", {
                            required: t(
                              translationConstants.FREELANCE_REGULATION_REQUIRED
                            ),
                          })}
                        />
                        <span
                          onClick={() => window.open(SSFRegulationsFreelancer)}
                          className="fs-10 link-style ms-1"
                        >
                          {t(
                            translationConstants.SSF_FREELANCER_REGULATIONS
                          )}
                        </span>
                        {errors.freelanceRegulation && (
                          <p className="errorText">
                            {errors.freelanceRegulation.message}
                          </p>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                  <div className="row w-100 mb-5">
                    <div className="d-flex justify-content-center align-items-center">
                      <Button className="Submit-button mt-1" type="submit">
                        {t(translationConstants.PROCEED_TO_PAYMENT)}
                      </Button>
                    </div>
                  </div>
                </Form>
              </section>
            </section>
          </BaseForm>
        </CustomModal>

        <CustomModal
          size={"sm"}
          scrollable={true}
          setShow={onSetShowSmallModal}
          show={isShowSmallModal}
          customClass={"freelance-instructor-model-sm"}
          closeBtnClasses={"login-modal-close-btn"}
        >
          <div className="freelance-instructor-model-sm">
            <p className="pricing-heading mt-3">
              {t(translationConstants.PRICING_BREAKDOWN)}
            </p>
            <hr />
            <div className="d-flex justify-content-between mt-4">
              <p className="subscritption">
                {t(translationConstants.SUBSCRITION_FEE)}
                <span>({t(translationConstants.YEAR)})</span>
              </p>
              <span className="sar">({translationConstants.SAR})</span>
            </div>
            {pricing.map((data) => {
              return (
                <>
                  <div className="d-flex justify-content-between mt-3">
                    <p>
                      {data.sport === subscriptionTypeConstants.SAILING
                        ? t(translationConstants.sailing)
                        : data.sport === subscriptionTypeConstants.KITE_SURFING
                        ? t(translationConstants.kitesurfing)
                        : data.sport === subscriptionTypeConstants.WING_FOILING
                        ? t(translationConstants.wingfoiling)
                        : data.sport === subscriptionTypeConstants.WIND_SURFING
                        ? t(translationConstants.windsurfing)
                        : ""}
                    </p>
                    <p>{data.price}</p>
                  </div>
                  <hr />
                </>
              );
            })}
            <div className="mt-4">
              <div className="d-flex justify-content-between w-100">
                <div>
                  <p className="footer-text">
                    {t(translationConstants.SUB_TOTAL)}
                  </p>
                </div>
                <div>
                  <p className="footer-text">
                    {currentSAR.current?.toFixed(2)}
                  </p>
                </div>
              </div>
              <div className="d-flex justify-content-between w-100">
                <div>
                  <p className="footer-text">
                    {t(translationConstants.VAT)}{" "}
                    <span dir={Directions.ltr}>({vat}%)</span>
                  </p>
                </div>
                <div>
                  <p className="footer-text">
                    {calculateVAT(vat, currentSAR.current).toFixed(2)}
                  </p>
                </div>
              </div>
              <div className="d-flex justify-content-between w-100">
                <div>
                  <p className="footer-text">
                    {t(translationConstants.TOTAL_FEE)}
                  </p>
                </div>
                <div>
                  <p className="footer-text">{getTotalPriceYearly}</p>
                </div>
              </div>
            </div>
            <div className="text-center mt-3 font-8">
              {`${t(translationConstants.VAT)}: ${
                process.env.REACT_APP_VAT_NO
              }`}
            </div>
          </div>
        </CustomModal>

        <CustomModal
          scrollable
          show={isMemberModal}
          setShow={membershipModalHandler}
          size="sm"
          closeBtnClasses={"login-modal-close-btn"}
        >
          <BaseForm>
            <GeneralLogo />
            <BecomeFreelanceInstructorPayment
              title={t(translationConstants.BECOME_FREELANCE_INSTRUCTOR)}
              price={currentSAR}
              vat={vat}
              sportIds={sportIds}
              spotId={spotId}
              sportsSelectionModal={props.setShow}
              membershipModalHandler={membershipModalHandler}
              onSetShowSmallModal={onSetShowSmallModal}
            />
          </BaseForm>
        </CustomModal>
      </div>
    </>
  );
};

export default BecomeFreelanceInstructor;
